import React, { useState } from "react";
import Header from "./Header";
import { FacebookShareButton, FacebookIcon } from "react-share";
import { useStateValue } from "../Context/StateProvider";
import { useNavigate } from "react-router-dom";
import { getAuth } from "firebase/auth";
import { app } from "../config/firebase.config";

const UserProfile = () => {
  const navigate = useNavigate();
  const [{ user }, dispatch] = useStateValue();

  // const [isMenu, setIsMenu] = useState(false);

  const logout = () => {
    const firebaseAuth = getAuth(app);
    firebaseAuth
      .signOut()
      .then(() => {
        window.localStorage.setItem("auth", "false");
      })
      .catch((e) => console.log(e));
    navigate("/login", { replace: true });
  };

  return (
    <div className="w-full h-auto flex flex-col items-center justify-center bg-primary">
      <Header />
      <img
        className="w-12 min-w-[44px] object-cover rounded-full shadow-lg mb-3 z-50"
        src={user?.user?.imageURL}
        alt=""
        referrerpolicy="no-referrer"
      />
      <p className="text-blue-600 font-serif text-4xl">User Profile</p>
      <p className="mt-7 mb-5 font-serif text-2xl">{user?.user.name}</p>
      <div>
        <FacebookShareButton
          url="https://www.facebook.com/"
          quote="Asu"
          hashtag="#muo"
        >
          <FacebookIcon className="rounded-full" />
        </FacebookShareButton>
      </div>
      <div>
        <p
          className="text-red-600 text-1xl font-bold bg-white p-1 hover:bg-gray-300 duration-500 rounded-md cursor-pointer transition-all ease-in-out"
          onClick={logout}
        >
          Sign out. <em className="text-sm text-blue-700">{user?.user.name}</em>
        </p>
      </div>
    </div>
  );
};

export default UserProfile;
